// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_REVENUE_CHARTS_DATA = "GET_REVENUE_CHARTS_DATA";